import { IUserProfile } from '@collections/users/interfaces';
import {gql, TypedDocumentNode} from 'apollo-angular';
import { companyBaseFragment } from '../../company/fragments/company-base.fragments';

export const UserCompanyFragment: TypedDocumentNode<any> = gql`
  fragment userCompany on UserCompany {
      primary
      company(lang: $lang) {
        ...companyBase
      }
      qualification
  }
  ${companyBaseFragment}
`;

export const UserProfileBaseFragment: TypedDocumentNode<IUserProfile> = gql`
  fragment userProfileBase on UserProfile {
    _id
    lang
    countryCode
    fullName
    picture
    followedCompanies(lang: $lang) {
      _id
    }
    savedProducts(lang: $lang) {
      _id
    }
    savedNews{
      _id
    }
    userCompanies {
      ...userCompany
    }
  }
  ${UserCompanyFragment}
  `;

export const UserProfileFragment = gql`
  fragment userProfile on UserProfile
  {
    ...userProfileBase
    firstName
    lastName
    description
    emails {
      email
      primary
      verified
    }
    socials {
      name
      url
    }
    birthday
    businessArea
    fieldsOfInterest
    materials
    telephone
    mobile
    percentCompleted
  }
  ${UserProfileBaseFragment}
  `;
